import React from "react";
import { useNavigate } from "react-router-dom";

import { routes } from "consts";
import { FinanceCategoryForm, FinanceCategoryFormValues } from "./FinanceCategoryForm/FinanceCategoryForm";
import { HeaderWithBreadcrumbs } from "components/molecules/HeaderWithBreadcrumbs/HeaderWithBreadbrumbs";
import { useToaster } from "utils";
import { PaziaButton } from "components/atoms";
import { PageMain } from "components/molecules";
import { courseFinanceCategoriesApi } from "api/course-finances";

export const FinanceCategoryAddPage = (): JSX.Element | null => {
  const navigate = useNavigate();
  const { showSuccess } = useToaster();

  const onSubmit = async (data: FinanceCategoryFormValues) => {
    await courseFinanceCategoriesApi.create(data);
    navigate(routes.COURSE_FINANCES_CATEGORIES);
    showSuccess("Kategoria została dodana");
  };

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        headerText="Dodaj nową kategorię"
        headerButton={
          <PaziaButton type="primary" title="Dodaj +" onClick={() => navigate(routes.COURSE_FINANCES_CATEGORIES_ADD)} />
        }
        breadcrumbs={[
          { title: "Finanse", path: routes.FINANCES },
          { title: "Kategorie płatności", path: routes.COURSE_FINANCES_CATEGORIES },
          { title: "Tworzenie nowej kategorii" },
        ]}
      />

      <FinanceCategoryForm onSubmit={onSubmit} />
    </PageMain>
  );
};
